import { useSelector } from '@xstate/store/react';
import isEqual from 'lodash/isEqual';

import { templateBuilderStore } from './templateBuilderStore';

export const useIsStateDirty = () => {
  return useSelector(templateBuilderStore, (state) => {
    const { originalState } = state.context;
    const currentState = state.context;

    return (
      originalState?.name !== currentState.name ||
      originalState?.outputType !== currentState.outputType ||
      originalState?.description !== currentState.description ||
      originalState?.variantNotes !== currentState.variantNotes ||
      !isEqual(originalState?.blocks, currentState.blocks)
    );
  });
};
